import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './block-files.scss';

export class BlockFiles extends PureComponent {
  render() {
    const files = this.props.content.items
      .filter(item => !!item.link);

    if (files.length === 0) {
      return null;
    }

    return (
      <div className="block-files">
        <h5 dangerouslySetInnerHTML={{ __html: this.props.content.title }} />

        <ul>
          {files.map((file, key) =>
            <li key={key}>
              <div className={cn('block-files-item', file.extension)}>
                <h6 dangerouslySetInnerHTML={{ __html: file.title }} />

                <a
                  className="btn btn-arrowed"
                  href={file.link}
                >
                  <span>подробнее</span>

                  <span className="icon">→</span>
                </a>
              </div>
            </li>
          )}
        </ul>
      </div>
    );
  }
}

BlockFiles.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        link: PropTypes.string,
        extension: PropTypes.oneOf(['pdf', 'doc'])
      })
    )
  })
};

export default BlockFiles;



// WEBPACK FOOTER //
// ./src/components/widgets/Typography/BlockFiles.js